var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalender = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.00781,11.32812h-6.79687V0H109.88281V11.32812H35.11719V0H23.78906V11.32812H16.99219A16.99219,16.99219,0,0,0,0,28.32031v99.6875A16.99219,16.99219,0,0,0,16.99219,145H128.00781A16.99219,16.99219,0,0,0,145,128.00781V28.32031A16.99219,16.99219,0,0,0,128.00781,11.32812Zm0,122.34376H16.99219a5.66407,5.66407,0,0,1-5.66407-5.66407V53.24219H133.67188v74.76562A5.66407,5.66407,0,0,1,128.00781,133.67188Zm5.66407-91.75782H11.32812V28.32031a5.66407,5.66407,0,0,1,5.66407-5.66406h6.79687V33.98438H35.11719V22.65625h74.76562V33.98438h11.32813V22.65625h6.79687a5.66407,5.66407,0,0,1,5.66407,5.66406Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.52344,
    y: 65.13672,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.17969,
    y: 65.13672,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.83594,
    y: 65.13672,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.49219,
    y: 65.13672,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.14844,
    y: 65.13672,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.52344,
    y: 87.79297,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.17969,
    y: 87.79297,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.83594,
    y: 87.79297,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.49219,
    y: 87.79297,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.52344,
    y: 110.44922,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.17969,
    y: 110.44922,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.83594,
    y: 110.44922,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.49219,
    y: 110.44922,
    width: 11.32813,
    height: 11.32813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.14844,
    y: 87.79297,
    width: 11.32813,
    height: 11.32813
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalender);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "24d7f7a9464067f2286d7b88c6032c64.svg";